import * as Sentry from '@sentry/react';

// Error monitoring — no-op unless VITE_SENTRY_DSN is configured at build time
// Wrapped in try/catch: a malformed DSN must never white-page the app —
// monitoring is optional, the product is not.
try {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
    });
  }
} catch (e) {
  console.error('Sentry init skipped:', e?.message);
}

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './ErrorBoundary.jsx'
import './index.css'

// Root boundary: whatever goes wrong anywhere in the tree — a failed chunk
// after lazyRetry's one reload, a render crash, anything — the user sees
// the friendly "something went wrong / Reload" screen, never a blank page.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
